import { create } from "zustand";
import { leitenRecord } from "../../leiten/controllers/leitenRecord";
/**
 * A variable that represents a state object for error handling.
 *
 * @typedef {Object} ErrorPageState
 * @property {IErrorState | null} error - The error state object or null if no error occurred.
 */
export const useErrorPage = create(() => ({
    error: null,
}));
export const setErrorPage = leitenRecord(useErrorPage, "error");
